"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifyCustomerByCustomerNumberRequestPayloadToJSON = exports.IdentifyCustomerByCustomerNumberRequestPayloadFromJSONTyped = exports.IdentifyCustomerByCustomerNumberRequestPayloadFromJSON = void 0;
var runtime_1 = require("../runtime");
function IdentifyCustomerByCustomerNumberRequestPayloadFromJSON(json) {
    return IdentifyCustomerByCustomerNumberRequestPayloadFromJSONTyped(json, false);
}
exports.IdentifyCustomerByCustomerNumberRequestPayloadFromJSON = IdentifyCustomerByCustomerNumberRequestPayloadFromJSON;
function IdentifyCustomerByCustomerNumberRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customerNo': json['customerNo'],
        'dateOfBirth': !(0, runtime_1.exists)(json, 'dateOfBirth') ? undefined : json['dateOfBirth'],
    };
}
exports.IdentifyCustomerByCustomerNumberRequestPayloadFromJSONTyped = IdentifyCustomerByCustomerNumberRequestPayloadFromJSONTyped;
function IdentifyCustomerByCustomerNumberRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customerNo': value.customerNo,
        'dateOfBirth': value.dateOfBirth,
    };
}
exports.IdentifyCustomerByCustomerNumberRequestPayloadToJSON = IdentifyCustomerByCustomerNumberRequestPayloadToJSON;
//# sourceMappingURL=IdentifyCustomerByCustomerNumberRequestPayload.js.map